import getParent from "@/utils/getParent";
import { merge } from "lodash";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { MutiMng } from "./expose";
import { getAttribute, getCommonData, getFilter } from "./get";

const ContainerMng = new MutiMng({
  dataKey: "board_id",
  key: "board_source",
  reporterKeys: {
    ids: "board_ids",
    number: "board_number",
  },
  extKeys: [{ key: "board_location", reporterKey: "board_locations" }],
});

export function board_expose(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33007,
    event_name: "board_expose",
    board_id: targetNode.getAttribute("data-board-id"),
    board_location: targetNode.getAttribute("data-board_location"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.topic_title = el.getAttribute("data-topic-title");
      trackData.topic_id = el.getAttribute("data-topic-id");
    }
  }

  getCommonData(targetNode, trackData);

  merge(trackData, getFilter(page.page_nm, targetNode));

  ContainerMng.add(trackData);
}

export function board_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33008,
    event_name: "board_click",
    board_id: targetNode.getAttribute("data-board-id"),
    board_location: targetNode.getAttribute("data-board_location"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");
  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  const search_word = getAttribute(targetNode, "data-search-word");
  if (search_word) {
    trackData.search_word = search_word;
  }

  if (page_nm === "采集详情页" && trackData.search_word) {
    getSearchData(trackData);
  }

  getCommonData(targetNode, trackData);

  merge(trackData, getFilter(page.page_nm, targetNode));

  reporter(trackData);
}
